import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface SmallBodyMediumTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
  className?: string
}

export const SmallBodyMediumText: FC<SmallBodyMediumTextProps> = ({ children, className = '', ...rest }) => (
  <p className={`small-body-medium-text ${className}`} {...rest}>
    {children}
  </p>
)
